import * as Types from '@frameio/graphql-client/generated/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';

import { useQuery, useLazyQuery, useMutation, useFragment, useSubscription } from '@apollo/client';
import type { QueryHookOptions, LazyQueryHookOptions, MutationHookOptions, SubscriptionHookOptions, UseFragmentOptions } from '@apollo/client';

export type AccountRequirePassphrasePoliciesFragment = { __typename?: 'Account', id: string, resourceControlPolicies?: { __typename?: 'ResourceControlPolicies', sharePassphrase?: { __typename?: 'SharePassphraseSettings', required?: boolean | null, adminCanDisableInShares?: boolean | null, fullAccessCanDisableInShares?: boolean | null, editAndShareCanDisableInShares?: boolean | null } | null } | null };

export type WorkspaceRequirePassphrasePoliciesFragment = { __typename?: 'Workspace', id: string, appliedResourceControlPolicies?: { __typename?: 'ResourceControlPolicies', sharePassphrase?: { __typename?: 'SharePassphraseSettings', required?: boolean | null } | null } | null, resourceControlPolicies?: { __typename?: 'WorkspaceResourceControlPolicies', sharePassphrase?: { __typename?: 'SharePassphraseSettings', required?: boolean | null, adminCanDisableInShares?: boolean | null, fullAccessCanDisableInShares?: boolean | null, editAndShareCanDisableInShares?: boolean | null } | null } | null };

export type ShareRequirePassphrasePolicies_AdHocAssetsShare_Fragment = { __typename?: 'AdHocAssetsShare', id: string, project?: { __typename?: 'Project', id: string, appliedResourceControlPolicies?: { __typename?: 'ResourceControlPolicies', sharePassphrase?: { __typename?: 'SharePassphraseSettings', required?: boolean | null } | null } | null, permissions?: { __typename?: 'ProjectPermissions', canDisablePassphraseInShares?: boolean | null } | null } | null };

export type ShareRequirePassphrasePolicies_CollectionShare_Fragment = { __typename?: 'CollectionShare', id: string, project?: { __typename?: 'Project', id: string, appliedResourceControlPolicies?: { __typename?: 'ResourceControlPolicies', sharePassphrase?: { __typename?: 'SharePassphraseSettings', required?: boolean | null } | null } | null, permissions?: { __typename?: 'ProjectPermissions', canDisablePassphraseInShares?: boolean | null } | null } | null };

export type ShareRequirePassphrasePoliciesFragment = ShareRequirePassphrasePolicies_AdHocAssetsShare_Fragment | ShareRequirePassphrasePolicies_CollectionShare_Fragment;

export const AccountRequirePassphrasePolicies = /*#__PURE__*/ gql`
    fragment AccountRequirePassphrasePolicies on Account {
  id
  resourceControlPolicies {
    sharePassphrase {
      required
      adminCanDisableInShares
      fullAccessCanDisableInShares
      editAndShareCanDisableInShares
    }
  }
}
    ` as unknown as DocumentNode<AccountRequirePassphrasePoliciesFragment, unknown>;
export const WorkspaceRequirePassphrasePolicies = /*#__PURE__*/ gql`
    fragment WorkspaceRequirePassphrasePolicies on Workspace {
  id
  appliedResourceControlPolicies {
    sharePassphrase {
      required
    }
  }
  resourceControlPolicies {
    sharePassphrase {
      required
      adminCanDisableInShares
      fullAccessCanDisableInShares
      editAndShareCanDisableInShares
    }
  }
}
    ` as unknown as DocumentNode<WorkspaceRequirePassphrasePoliciesFragment, unknown>;
export const ShareRequirePassphrasePolicies = /*#__PURE__*/ gql`
    fragment ShareRequirePassphrasePolicies on Share {
  id
  project {
    id
    appliedResourceControlPolicies {
      sharePassphrase {
        required
      }
    }
    permissions {
      canDisablePassphraseInShares
    }
  }
}
    ` as unknown as DocumentNode<ShareRequirePassphrasePoliciesFragment, unknown>;

        

        
export const useAccountRequirePassphrasePoliciesFragment = (
  input: string | Omit<UseFragmentOptions<AccountRequirePassphrasePoliciesFragment, any>, 'fragment' | 'fragmentName'> | undefined | null
) => {
  const options = (() => {
    if (!input) return { from: null };
    if (typeof input === 'string') return { from: { id: input, __typename: 'Account' } };
    return input;
  })();

  return useFragment<AccountRequirePassphrasePoliciesFragment>({
    fragment: AccountRequirePassphrasePolicies,
    fragmentName: 'AccountRequirePassphrasePolicies',
    ...options,
  });
};
  
        
        

        
export const useWorkspaceRequirePassphrasePoliciesFragment = (
  input: string | Omit<UseFragmentOptions<WorkspaceRequirePassphrasePoliciesFragment, any>, 'fragment' | 'fragmentName'> | undefined | null
) => {
  const options = (() => {
    if (!input) return { from: null };
    if (typeof input === 'string') return { from: { id: input, __typename: 'Workspace' } };
    return input;
  })();

  return useFragment<WorkspaceRequirePassphrasePoliciesFragment>({
    fragment: WorkspaceRequirePassphrasePolicies,
    fragmentName: 'WorkspaceRequirePassphrasePolicies',
    ...options,
  });
};
  
        
        

        
export const useShareRequirePassphrasePoliciesFragment = (
  input: string | Omit<UseFragmentOptions<ShareRequirePassphrasePoliciesFragment, any>, 'fragment' | 'fragmentName'> | undefined | null
) => {
  const options = (() => {
    if (!input) return { from: null };
    if (typeof input === 'string') return { from: { id: input, __typename: 'Share' } };
    return input;
  })();

  return useFragment<ShareRequirePassphrasePoliciesFragment>({
    fragment: ShareRequirePassphrasePolicies,
    fragmentName: 'ShareRequirePassphrasePolicies',
    ...options,
  });
};
  
        